define('home/mixins/asProfileCard',[
    'underscore',

    'home/models/Session',

    'home/utils/layoutUtils',
    'home/mixins/withAllstarPopover',
    'home/mixins/withTruncate',
], function (
    _,

    Session,

    layoutUtils,
    withAllstarPopover,
    withTruncate
) {
    'use strict';

    var asProfileCard = function () {
        withTruncate.apply(this, arguments);
        withAllstarPopover.call(this);

        this.initialize = _.wrap(this.initialize, function (_initialize) {
            _initialize.apply(this, _.rest(arguments));
            this.session = Session.get();

            // Ensure computations for values that will be used in this view
            this.model.thread.isAuthorSessionUser(this.session);

            this.listenTo(this.model.thread, 'change:content change:isAuthor', this.render);
            this.listenTo(this.session, 'change:id', this.render);

            this.numTitleLines = 3;
        });

        this.serializeData = _.wrap(this.serializeData, function (_serializeData) {
            var data = _serializeData.apply(this, _.rest(arguments));
            var thread = this.model.thread;

            return _.defaults(data, {
                discussionRoute: thread && thread.getDiscussionRoute(),
                canShowThreadImage: !layoutUtils.isNarrowLayout(),
                image: thread && thread.getImage(),
                numTitleLines: this.numTitleLines,
                relativeTime: this.model.getRelativeTimestamp(),
                firstActor: this.model.actors[0] && this.model.actors[0].toJSON(),
                isSpam: thread.get('isSpam'),
                isAuthor: thread.get('isAuthor'),
            });
        });
    };

    return asProfileCard;
});

